import { TextRenderConfig } from "./TextRenderConfig";
export function measureFont(ctx, font, bold) {
    let size = TextRenderConfig.standardFontSize;
    ctx.font = (bold ? 'bold ' : '') + size + 'px ' + font;
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.textBaseline = "middle";
    ctx.lineWidth = 0;
    ctx.fillStyle = "red";
    let margin = 16;
    const pixelBBX = [0, 0, 0, 0];
    pixelBBX[0] = size / 2;
    pixelBBX[1] = size / 2;
    pixelBBX[2] = size;
    pixelBBX[3] = size;
    drawTestChar(ctx, 'g', size, margin, pixelBBX);
    drawTestChar(ctx, '有', size, margin, pixelBBX);
    let xoff = Math.max(margin - pixelBBX[0], 0);
    let yoff = Math.max(margin - pixelBBX[1], 0);
    let bbxw = pixelBBX[2] - pixelBBX[0] + 1;
    let bbxh = pixelBBX[3] - pixelBBX[1] + 1;
    drawTestChar(ctx, '🤡', size, margin, pixelBBX, true);
    let eoff = Math.max(margin - pixelBBX[1], 0) - yoff;
    let ebbxh = pixelBBX[3] - pixelBBX[1] + 1;
    return { xoff, yoff, bbxw, bbxh, eoff, ebbxh };
}
function drawTestChar(ctx, char, fontSize, margin, pixelBBX, onlyH) {
    let charWidth = ctx.measureText(char).width;
    let width = Math.floor(charWidth + margin * 2);
    let height = Math.floor(fontSize + margin * 2);
    ctx.clearRect(0, 0, width, height);
    ctx.fillText(char, margin, margin + fontSize / 2);
    let bmp = ctx.getImageData(0, 0, width, height);
    updateBbx(bmp, pixelBBX, onlyH);
}
function updateBbx(data, curbbx, onlyH) {
    let bmpData32 = new Uint32Array(data.data.buffer);
    function checkBmpLine(data, l, sx, ex) {
        let stpos = data.width * l + sx;
        for (let x = sx; x < ex; x++) {
            if (bmpData32[stpos++] !== 0)
                return true;
        }
        return false;
    }
    let w = data.width;
    let h = data.height;
    let x = 0;
    let sy = curbbx[1];
    let ey = 0;
    let y = sy;
    if (checkBmpLine(data, sy, 0, w)) {
        while (true) {
            y = (sy + ey) / 2 | 0;
            if (y + 1 >= sy) {
                curbbx[1] = y;
                break;
            }
            if (checkBmpLine(data, y, 0, w)) {
                sy = y;
            }
            else {
                ey = y;
            }
        }
    }
    if (curbbx[3] > h)
        curbbx[3] = h;
    else {
        y = sy = curbbx[3];
        ey = h;
        if (checkBmpLine(data, sy, 0, w)) {
            while (true) {
                y = (sy + ey) / 2 | 0;
                if (y - 1 <= sy) {
                    curbbx[3] = y;
                    break;
                }
                if (checkBmpLine(data, y, 0, w)) {
                    sy = y;
                }
                else {
                    ey = y;
                }
            }
        }
    }
    if (onlyH)
        return;
    let minx = curbbx[0];
    let stpos = w * curbbx[1];
    for (y = curbbx[1]; y < curbbx[3]; y++) {
        for (x = 0; x < minx; x++) {
            if (bmpData32[stpos + x] !== 0) {
                minx = x;
                break;
            }
        }
        stpos += w;
    }
    curbbx[0] = minx;
    let maxx = curbbx[2];
    stpos = w * curbbx[1];
    for (y = curbbx[1]; y < curbbx[3]; y++) {
        for (x = maxx; x < w; x++) {
            if (bmpData32[stpos + x] !== 0) {
                maxx = x;
                break;
            }
        }
        stpos += w;
    }
    curbbx[2] = maxx;
}
